export const meKeys = {
  all: ['me'] as const,
};
